var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-navbar gfu-navbar--lighter gfu-navbar--elevate _jc-c" },
    [
      _c(
        "div",
        {
          staticClass:
            "gfu-navbar-nav gfu-navbar-nav--scrollable gfu-navbar-nav--secondary",
        },
        [
          _c(
            "div",
            {
              staticClass: "gfu-navbar-nav__wrapper",
              attrs: { "data-qa": `${_vm.dataQaPrefix}-navbar` },
            },
            _vm._l(_vm.navigationItems, function (item) {
              return _c(
                "div",
                {
                  key: item.label,
                  ref: item.ref,
                  refInFor: true,
                  class: item.classes,
                  attrs: { "data-qa": item.dataQa },
                },
                [
                  _c(
                    item.component,
                    {
                      tag: "component",
                      staticClass: "gfu-navbar-link",
                      attrs: { href: item.href, to: item.route },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "gfu-link-underline__content",
                          attrs: { "data-qa": `${_vm.dataQaPrefix}-nav-title` },
                        },
                        [_vm._v(_vm._s(item.label))]
                      ),
                      _vm._v(" "),
                      item.isBadgeVisible
                        ? _c(
                            "span",
                            {
                              staticClass: "gfu-navbar-badge _ml-1",
                              attrs: {
                                "data-qa": `${_vm.dataQaPrefix}-nav-count`,
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.number) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }